<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard">
		<p-toast key="toastmsg"></p-toast>

		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Tournament List<span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
			</div>
		</div>

		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							[showIcon]="true" placeholder="From: dd / mm / yy"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							[showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
					</li>
					<li>
						<button (click)="loadAcademyTournaments($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>
			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class=" expandable" #dt [value]="academyTournamentsList" [paginator]="true" [rows]="10"
						[lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
						(onLazyLoad)="loadAcademyTournaments($event)" [totalRecords]="totalRecords" [loading]="loading"
						[rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pfrozencolumn="" class="p-element text-nowrap nameTD" style="left: 0px;"
									pSortableColumn="academyName">
									<div class="p-d-flex p-jc-between p-ai-center">
										Academy Name
										<p-sortIcon field="academyName"></p-sortIcon>
									</div>
								</th>
								<th pfrozencolumn="" class="p-element text-nowrap nameTD" style="left: 0px;"
									pSortableColumn="name">
									<div class="p-d-flex p-jc-between p-ai-center">
										Tournament Name
										<p-sortIcon field="name"></p-sortIcon>
									</div>
								</th>
								<th class="RegistrationTD" pSortableColumn="lastdateofregistration">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Date
										<p-sortIcon field="lastdateofregistration"></p-sortIcon>
									</div>
								</th>
								<th class="WithdrawalTD" pSortableColumn="lastdateofwithdraw">
									<div class="p-d-flex p-jc-between p-ai-center">
										Withdrawal Date
										<p-sortIcon field="lastdateofwithdraw"></p-sortIcon>
									</div>
								</th>
								<th class="TournamentstartTD" pSortableColumn="startdate">
									<div class="p-d-flex p-jc-between p-ai-center">
										Start Date
										<p-sortIcon field="startdate"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="col-150 statusTD" >
									<div class="p-d-flex p-jc-between p-ai-center">
										Tournament Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th class="TournamentendTD" pSortableColumn="enddate">
									<div class="p-d-flex p-jc-between p-ai-center">
										End Date
										<p-sortIcon field="enddate"></p-sortIcon>
									</div>
								</th>

								<th pSortableColumn="organizercontactnumber" class="OrganizerTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Organizer Number
										<p-sortIcon field="organizercontactnumber"></p-sortIcon>
									</div>
								</th>
								
								<th class="LastModifiedTD" pSortableColumn="updated_at"
									[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>

								<!-- <th pSortableColumn="created_at"
										[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
										<div class="p-d-flex p-jc-between p-ai-center">
											Date of Creation
											<p-sortIcon field="created_at"></p-sortIcon>
										</div>
									</th> -->
								<!-- <th pSortableColumn="created_by"
										[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
										<div class="p-d-flex p-jc-between p-ai-center">
											Created By
											<p-sortIcon field="created_by"></p-sortIcon>
										</div>
									</th> -->

								<!-- <th pSortableColumn="updated_by"
										[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
										<div class="p-d-flex p-jc-between p-ai-center">
											Modified By
											<p-sortIcon field="updated_by"></p-sortIcon>
										</div>
									</th> -->

								<th class="text-nowrap p-element p-frozen-column actionTD" pfrozencolumn=""
									alignfrozen="right" style="justify-content: center;">
									Action
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="academyName" pfrozencolumn="" class="p-element text-nowrap nameTD"
									style="left: 0px;">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
										[value]="dt.filters['academyName'] ? dt.filters['academyName'].value : ''" />
								</th>
								<th [ngSwitch]="name" pfrozencolumn="" class="p-element text-nowrap nameTD"
									style="left: 0px;">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'name', 'contains')"
										[value]="dt.filters['name'] ? dt.filters['name'].value : ''" />
								</th>
								<th [ngSwitch]="lastdateofregistration" class="RegistrationTD">
									<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
										inputId="calendar" dateFormat="dd-mm-yy"
										[(ngModel)]="lastdateofregistrationvalue"
										(onSelect)="setDownloadFlag(); dt.filter($event,'lastdateofregistration', 'dateIs')"
										appendTo="body" monthNavigator="true" yearNavigator="true"
										yearRange="2000:2030"></p-calendar>
								</th>
								<th [ngSwitch]="lastdateofwithdraw" class="WithdrawalTD">
									<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
										inputId="calendar" dateFormat="dd-mm-yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'lastdateofwithdraw', 'dateIs')"
										[showIcon]="false" appendTo="body" monthNavigator="true" yearNavigator="true"
										yearRange="2000:2030" [(ngModel)]="lastdateofwithdrawvalue"></p-calendar>
								</th>
								<th [ngSwitch]="startdate" class="TournamentstartTD">
									<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
										inputId="calendar" dateFormat="dd-mm-yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'startdate', 'dateIs')"
										[showIcon]="false" appendTo="body" monthNavigator="true" yearNavigator="true"
										yearRange="2000:2030" [(ngModel)]="startdatevalue"></p-calendar>
								</th>
								
								<th [ngSwitch]="status" class="col-150 statusTD" >
									<p-dropdown appendTo="body" #pDropDownId [options]="statuses"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
										placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th [ngSwitch]="enddate" class="TournamentendTD">
									<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
										inputId="calendar" dateFormat="dd-mm-yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'enddate', 'dateIs')"
										[showIcon]="false" appendTo="body" monthNavigator="true" yearNavigator="true"
										yearRange="2000:2030" [(ngModel)]="enddatevalue"></p-calendar>
								</th>

								<th [ngSwitch]="organizercontactnumber" pfrozencolumn=""
									class="p-element OrganizerTD text-nowrap">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'organizercontactnumber', 'contains')"
										[value]="dt.filters['organizercontactnumber'] ? dt.filters['organizercontactnumber'].value : ''" />
								</th>


								<th class="LastModifiedTD" [ngSwitch]="created_at"
									[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
									<p-calendar #pCalendarId class="p-column-filter" readonlyInput="true" inputId="calendar"
																	dateFormat="dd-mm-yy"
																	(onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
																	[showIcon]="true" appendTo="body" monthNavigator="true" yearNavigator="true"
																	yearRange="2000:2030" showButtonBar="true" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<!-- <th [ngSwitch]="createdby"
										[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
										<input pInputText type="text"
											(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'createdby', 'contains')"
											style="width: 90px;"
											[value]="dt.filters['createdby'] ? dt.filters['createdby'].value : ''" /> -->
								<!-- </th> -->
								<!-- <th [ngSwitch]="updatedby"
										[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
										<input pInputText type="text"
											(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'updatedby', 'contains')"
											style="width: 90px;"
											[value]="dt.filters['updatedby'] ? dt.filters['updatedby'].value : ''" />
									</th> -->


								<th class="text-nowrap p-element p-frozen-column actionTD"
									style="justify-content: center;">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-academyTournament>
							<tr class="p-selectable-row">
								<td pfrozencolumn="" class="p-element text-nowrap nameTD"
									style="left: 0px; z-index: 1001; display: flex;">
									<div class="textOverFlow1" pTooltip="	{{academyTournament.academyName}}"
										tooltipPosition="bottom">
										{{academyTournament.academyName}}
									</div>
								</td>
								<td pfrozencolumn="" class="p-element text-nowrap nameTD"
									style="left: 0px; z-index: 1001; display: flex;">
									<span class="textOverFlow1" pTooltip="	{{academyTournament.name}}" tooltipPosition="bottom">
										{{academyTournament.name}}
									</span>
								</td>
								<td class="RegistrationTD">
									{{academyTournament.lastdateofregistration|date:'dd-MM-yyyy'}}
								</td>
								<td class="WithdrawalTD">
									{{academyTournament.lastdateofwithdraw|date:'dd-MM-yyyy'}}
								</td>
								<td class="TournamentstartTD">
									{{academyTournament.startdate| date: 'dd-MM-yyyy'}}
								</td>
										<td class="col-150 statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="academyTournament.status"
											(onChange)="changeStatus(academyTournament)">

										</p-inputSwitch>
										<div class="label activeText" *ngIf="academyTournament.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!academyTournament.status">
											Inactive
										</div>
									</div>
								</td>
								<td class="TournamentendTD">
									{{academyTournament.enddate| date: 'dd-MM-yyyy'}}
								</td>

								<td class="OrganizerTD">
									{{academyTournament.organizercontactnumber}}
								</td>
								<!-- <td class=">
										{{academyTournament.updated_at | date: 'dd-MM-yyyy'}}
									</td> -->
						
								<!-- <td class="switch-tab tournamentstatusTD" [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
											<div class="checkbox p-d-flex align-items-center">
												<p-inputSwitch [(ngModel)]="academyTournament.status" (onChange)="changeStatus(academyTournament)"></p-inputSwitch>
												<div class="label">
													Active
												</div>
											</div>
									</td> -->
								<td class="LastModifiedTD"
									[ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
									{{academyTournament.updated_at | date: 'dd-MM-yyyy'}}
								</td>
								<!-- <td [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
										{{academyTournament.createdBy}}
									</td> -->
								<!-- <td [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
										{{academyTournament.updatedBy}}
									</td> -->
								<td class="text-nowrap p-element p-frozen-column actionTD" pfrozencolumn=""
									alignfrozen="right" style="justify-content: center;">
									<!-- <button *ngIf="academyTournament.status === 'created'" pButton pRipple icon="pi pi-lock-open"
											title="Mark Free" class="p-button-rounded p-button-info p-mr-2"
											(click)="markFree(academyTournament.id)"></button> -->
									<ul class="actionList">
										<li>
											<button (click)="editTournament(academyTournament)" class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
											<!-- 
												<button pButton pRipple icon="pi pi-pencil" title="Edit" class="p-button-rounded p-button-success p-mr-2 editBtn"
													(click)="editTournament(academyTournament)"></button> -->
										</li>

										<li>
											<button (click)="deleteTournament(academyTournament)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>

											<!-- <button pButton pRipple icon="pi pi-trash" title="Delete"
													class="p-button-rounded p-button-danger p-mr-2"
													(click)="deleteTournament(academyTournament)"></button> -->
										</li>

										<li>
											<button (click)="viewTournamentPlayerList(academyTournament)"
												class="viewBtn"><img
													src="../../../assets/images/backend-image/common-images/view.svg"></button>
											<!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-info p-mr-2" tooltipPosition="bottom"  pTooltip="View Tournament"
														(click)="viewTournamentPlayerList(academyTournament)"></button> -->
										</li>
									</ul>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Academy Tournament not found.</td>
							</tr>
						</ng-template>
						<!-- <ng-template pTemplate="summary">
								<div class="p-d-flex p-ai-center p-jc-between">
									In total there are {{totalRecords }} Academy Tournament.
								</div>
							</ng-template> -->
					</p-table>
				</div>
			</div>
		</div>


		<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
	</div>
</div>